import type { WidgetId } from '@wix/members-area-app-definitions';
import type { ComponentRef, FlowEditorSDK } from '@wix/yoshi-flow-editor';

import { MenuId } from '../../../constants';
import { getMenu } from '../../../editor/editor-sdk-wrappers';
import { removeMenuItemsByWidgetIds, updateMenuItemLabel } from './menu';

const MEMBERS_SUB_MENU_INNER_ELEMENTS_PATH = ['horizontalMenu1', 'navbar'];

export const removeProfilePageSubMenuItems = async (
  editorSDK: FlowEditorSDK,
  widgetsIds: WidgetId[],
) => {
  return removeMenuItemsByWidgetIds(
    editorSDK,
    MenuId.MembersSubMenu,
    widgetsIds,
  );
};

export const getProfilePageSubMenu = async (editorSDK: FlowEditorSDK) => {
  return getMenu(editorSDK, MenuId.MembersSubMenu);
};

export const updateProfilePageSubMenuItemLabel = async (
  editorSDK: FlowEditorSDK,
  widgetId: WidgetId,
  newLabel: string,
) => {
  return updateMenuItemLabel({
    editorSDK,
    menuId: MenuId.MembersSubMenu,
    widgetId,
    newLabel,
  });
};

export const connectMemberProfileSubMenuToInnerElements = async (
  editorSDK: FlowEditorSDK,
  menuCompRef: ComponentRef,
) => {
  await editorSDK.menu.connectToInnerElement('', {
    menuCompRef,
    menuId: MenuId.MembersSubMenu,
    innerElementsPath: MEMBERS_SUB_MENU_INNER_ELEMENTS_PATH,
  });
};
